import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  routes: [],
  loading: false,
  error: null,
  filters: {
    duration: null,
    difficulty: null,
    type: null,
  },
};

export const routesSlice = createSlice({
  name: 'routes',
  initialState,
  reducers: {
    setRoutes: (state, action) => {
      state.routes = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const { setRoutes, setLoading, setError, setFilters } = routesSlice.actions;

export default routesSlice.reducer;
